import React, { useLayoutEffect, useRef, useState } from 'react';
import arrowUp from "../../common/images/arrow_up.png";
import arrowDown from "../../common/images/arrow_down.png";
import './VentilatorSetParamsDesktopView.scss'

const COLLAPSED_HEIGHT = '12%';

function VentilatorSetParamsDesktopView({
    expanded,
    setExpanded,
    params
}) {
    const valuesRef = useRef(null);
    const [expandedHeight, setExpandedHeight] = useState(null);

    useLayoutEffect(() => {
        const el = valuesRef.current;
        if (!el) return;

        const measure = () => {
            if (expanded) {
                setExpandedHeight(el.scrollHeight);
            } else {
                setExpandedHeight(null);
            }
        };

        measure();

        const observer = new ResizeObserver(measure);
        observer.observe(el);
        window.addEventListener('resize', measure);

        return () => {
            observer.disconnect();
            window.removeEventListener('resize', measure);
        };
    }, [expanded, params.length]);

    const containerHeight = expanded && expandedHeight != null
        ? `${expandedHeight}px`
        : COLLAPSED_HEIGHT;

    return (
        <div
            className={`vital-footer-container${expanded ? ' expanded' : ''}`}
            style={{ height: containerHeight  , marginBottom: '0px' , bottom: '0px'}}
        >
            <div className="footer-param-box-values" ref={valuesRef}>
                {params.map((item, index) => (
                    <div className="footer-param-box" key={index}>
                        <div className="footer-param-name">{item.title}</div>
                        <div className="footer-param-value">{item.value}</div>
                        <div className="footer-param-unit">{item.unit}</div>
                    </div>
                ))}
            </div>

            <div
                className="footer-param-box-arrow"
                onClick={() => setExpanded(!expanded)}
            >
                <img
                    src={expanded ? arrowDown : arrowUp}
                    alt="toggle"
                />
            </div>
        </div>
    );
}


export default VentilatorSetParamsDesktopView;